import { Box, Button, Link, Stack, Text } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';
import SignUpComplete from '@/svgs/auth/complete-customer.svg';

const CustomerComplete: React.FC<{ firstName: string }> = ({ firstName }) => {
  const { t } = useTranslation('pages.signUp.form.customerComplete');

  return (
    <Stack flex={1} w="100%" h="100%" align="center" gap={{ base: 10, lg: 4 }}>
      <Box flexGrow={1}>
        <Stack justify="center" align="center">
          <Text
            fontSize={{ base: 'md', lg: 'xl' }}
            w="full"
            fontWeight="medium"
            textAlign="center"
          >
            {firstName + t('profileMade')}
          </Text>
          <Text w="100%" textAlign="center" color="gray.700">
            {t('welcome')} {t('lia')} {t('join')}
          </Text>
        </Stack>
        <Stack
          w="100%"
          py={{ base: 2, md: 12 }}
          align="center"
          justify="center"
          transform={{ base: 'scale(0.6)', md: 'scale(1)' }}
        >
          <SignUpComplete />
        </Stack>
      </Box>
      <Stack w="100%" align="center" gap={8} mt={{ base: 10, lg: 'auto' }}>
        <Button as={Link} href={routes.dashboard.url} w="full">
          {t('letsGetStart')}
        </Button>
      </Stack>
    </Stack>
  );
};

export default CustomerComplete;
